import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined, isNull } from 'util';
import { DatePipe } from '@angular/common';
import { Cxctrnvarios } from '../cxcinterfaces/cxctrnvarios';

import { CxccobromultipleService } from "../cxcservicios/cxccobromultiple.service";
import { Cxcdetcobmulti } from "../cxcinterfaces/cxcdetcobmulti";
import { Cxcenccobmulti } from "../cxcinterfaces/cxcencobmulti";
import { Cxctrnformapago } from '../cxcinterfaces/cxctrnformapago';


@Component({
  selector: 'app-cxccobromultiple',
  templateUrl: './cxccobromultiple.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxccobromultipleComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonRegresar: boolean;
  botonBorrar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;
  botonAsiento: boolean;
  botonVerAsiento: boolean;

  indicador: any;
  nuevoreg: boolean;

  auxiliar1: number;
  auxreporte: number = 0;
  strNombreForma: string;

  permisoprecobmulti: SegMaePermiso

  activeIndex
  indiceTablas
  cxcdetcobmultiSelected: Cxcdetcobmulti

  selectAll: boolean;
  editarCeldas: boolean;
  asiento: ''
  displayDialogReportes: boolean;
  displayAsiContable: boolean;

  //ag-grid
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDefcxccobmulti
  defaultColumnDefCarteraFormaPago;
  defaultColumnDefCarteraVarios;
  rowStyleFp
  largo: string;
  btneditConcil = true;
  choosedColorG: string = '#EDB77F';
  choosedColorSB: string;
  choosedColor: string;
  datedesde
  datehasta
  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  spin
  //dialogs
  displayDialogBusquedaFast: boolean;
  displayDialogAsiento: boolean;
  detalleFormaPago: Cxctrnformapago;

  detalleVariosSeleccionado: Cxctrnvarios;
  strCodigoContable = '';

  columDefcxcobmulti = [
    {
      headerName: 'S/N',
      field: 'SELECCIONADO',
      cellRendererFramework: AggridBanComponent,
      editable: (params) => {
        return false;
      },
      width: 50,
      onCellClicked: (params) => {
        this.docSeleccionado(params);
      }
    },
    {
      headerName: 'Nro. Documento', field: 'DETCOB_NRODOC', cellEditor: 'cellPrueba', width: 180, editable: (params) => {

        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 50,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Fecha', field: 'DETCOB_FECHA', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32
        }
      }
    },
    {
      headerName: 'Fecha Vec.', field: 'DETCOB_FECHAVENC', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32,
        }
      }
    },
    {
      headerName: 'Concepto', field: 'DETCOB_CONCEPTO', cellEditor: 'cellPrueba', width: 200, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 200,
        }
      }
    },
    {
      headerName: 'Saldo', field: 'DETCOB_SALDOINI', cellEditor: 'agSelectCellEditor', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'DETCOB_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Vendedor', field: 'VEN_NOMBRE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Nombre cliente', field: 'CLI_NOMBRE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    }
  ];
  columDefCarteraFormaPago = [
    {
      headerName: 'Tipo', field: 'TRNPAGO_TIPO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 4,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Código', field: 'CAJ_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFPcaja(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 35,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Número', field: 'TRNPAGO_NUMERO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 45,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Fecha', field: 'TRNPAGO_FECHA', cellEditor: 'cellPrueba', width: 150, editable: (params) => {

        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Ban', field: 'BANCLI_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFPtrnban(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 35,
          tienecalculos: true,
          int: true,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Nombre', field: 'BANCLI_NOMBRE', cellEditor: 'cellPrueba', width: 200, editable: (params) => {
        const boolEdit = this.isEditFPtrnban(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 100,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Número Cuenta', field: 'TRNPAGO_NROCTA', cellEditor: 'cellPrueba', width: 100,
      editable: p => {
        return (p.data.TRNPAGO_TIPO === 'TA' || p.data.TRNPAGO_TIPO === 'CH' ||  p.data.TRNPAGO_TIPO === 'DP');
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 25,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Concepto', field: 'TRNPAGO_CONCEPTO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 1000,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'TRNPAGO_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ];
  columDefCarteraVarios = [
    {
      headerName: 'Ref. Contable', field: 'CON_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 35,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Descripción', field: 'CON_NOMBRE', cellEditor: 'cellPrueba', width: 250, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 100
        }
      }
    },
    {
      headerName: 'Debe', field: 'DEBE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Haber', field: 'HABER', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ];
  constructor(
    public cxccobromultipleService: CxccobromultipleService,
    private init: NuevoComponentService, private messageService: MessageService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    private busqService: InvbusquedaService, private permisosService: PermisosService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyleFp = (params) => {

      if (params.data.APLORG_CODIGO === 'SISTEMA' &&
        params.data.TRNCOBRO_CONCEPTO.includes('CUOTA')) {
        return { background: 'rgb(255, 255, 170)' };
      }

      if (params.data.COLORDOCDEP === true) {
        return { background: 'rgb(255, 207, 185)' };
      }

      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
      if ((params.data.TRNCOBRO_FECHATRN === '' || params.data.TRNCOBRO_FECHATRN === null) &&
        (this.activeIndex === 1 || this.activeIndex === 2)) {
        return { background: '#AAFF00' };
      }
      if (params.data.COLORDOCCONC === true) {
        return { background: 'rgb(135, 234, 130)' };
      }
    };
    this.defaultColDefcxccobmulti = {
      editable: true,
      width: 130,
      objeto: 'cxcdetcobmulti'
    };
    this.defaultColumnDefCarteraFormaPago = {
      editable: true,
      width: 100,
      objeto: 'cxcformapagocobmulti'
    };
    this.defaultColumnDefCarteraVarios = {
      editable: true,
      width: 100,
      objeto: 'cxcvarioscobmulti'
    };
  }

  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAsiento = true;
    this.botonVerAsiento = true;
    this.activeIndex = 0;
    this.indiceTablas = 0;
    this.selectAll = false;

    this.displayDialogReportes = false;
    this.displayDialogAsiento = false;

    this.nuevoreg = true;
    this.largo = '630';
    this.choosedColorG = '#EDB77F'//'#804000';
    this.choosedColorSB = '#00FF00';
    this.choosedColor = '#AAFF00';
    this.strCodigoContable = ''


    this.cxccobromultipleService.cxcenccobmulti[this.indicador] = {}
    this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = []
    this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = [];
    this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = [];

    this.detalleVariosSeleccionado = {}
    this.detalleFormaPago = {}
    this.auditoriagral.obtenerConfiguracion1().subscribe((conf) => {
      this.cxccobromultipleService.hmpConfiguracion = conf;
    });
    this.cxcdetcobmultiSelected = {}
    await this.getPermisos();

  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoprecobmulti = data[0];
        } else {
          this.permisoprecobmulti = null;
        }
      } else {
        this.permisoprecobmulti = null;
      }
    } catch (e) {
      this.permisoprecobmulti = null;
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }

  manejarSenales(evento) {
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
    if (evento === 'Nuevo') {
      if (this.permisoprecobmulti.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoprecobmulti.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cobmul',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Buscar') {
      if (this.permisoprecobmulti.PERTODO === 1) {
        this.buscarregistro();
      } else {
        if (this.permisoprecobmulti.PERSELECCION === 1) {
          this.buscarregistro();
        } else {
          this.messageService.add({
            key: 'cobmul',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de búsqueda, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Cancelar') {
      this.cancelar();
    }
    if (evento === 'Guardar') {
      if (this.permisoprecobmulti.PERTODO === 1) {
        this.spin = true;
        this.guardar()
      } else {
        if (this.permisoprecobmulti.PERACTUALIZACION === 1) {
          this.spin = true;
          this.guardar()
        } else {
          this.messageService.add({
            key: 'cobmul',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Asiento') {
      this.generarasiento(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO);
    }
    if (evento === 'AsientoVer') {
      this.verAsiento();
    }
    if (evento === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (evento === 'Borrar') {
      if (this.permisoprecobmulti.PERTODO === 1) {
        this.confirmarborrar();
      } else {
        if (this.permisoprecobmulti.PERELIMACION === 1) {
          this.confirmarborrar();
        } else {
          this.messageService.add({
            key: 'cobmul',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Primero') {
      this.seleccionarRegistro('P')
    }
    if (evento === 'Anterior') {
      this.seleccionarRegistro('A')
    }
    if (evento === 'Siguiente') {
      this.seleccionarRegistro('S')
    }
    if (evento === 'Ultimo') {
      this.seleccionarRegistro('U')
    }

  }
  async seleccionarRegistro(tipo) {
    try {
      let cod=isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO)?'':this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
      const rs = await this.cxccobromultipleService.getregistro(tipo,cod)
      if (rs!== null && rs.length>0) {
        await this.encontrarregistro(rs[0].ENCCOB_CODIGO)
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al seleccionar el registro '+error.error
      });
    }
  }
  confirmarborrar() {
    let encond = this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO;
    let comprobante = this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE
    if (isNullOrUndefined(encond) || encond === '') {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe seleccionar un registro'
      });
      return
    }
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      key: 'cobmulConf',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO = ''
        await this.cxccobromultipleService.eliminarencocbmulti(encond)
        for (const iterator of this.cxccobromultipleService.cxcdetcobmulti[this.indicador]) {
          await this.cxccobromultipleService.actualizaEstadoFactura(iterator.DETCOB_NRODOC,iterator.CLI_CODIGO)
        }
        this.auditoriagral.registrarAuditoria('CXC_ENCCOBRO_MULTIPLE',
          encond + '/' + comprobante + '', 'E',
          '', '01', '', '', '', '').subscribe();

        this.cancelar();
        this.messageService.add({
          key: 'cobmul',
          severity: 'success',
          summary: 'Información',
          detail: 'Éxito al eliminar '
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  verAsiento() {
    this.asiento = this.cxccobromultipleService.cxcenccobmulti[this.indicador].ASI_NRO;
    if (this.asiento === null || this.asiento === undefined || this.asiento === '') {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'No ha generado el Asiento Contable'
      });
    } else {
      this.auxiliar1++;
      // this.displayDialogAsiento = true;
      this.displayAsiContable = true;
    }
  }
  async guardar() {
    let docselected = this.cxccobromultipleService.cxcdetcobmulti[this.indicador].filter(x => x.SELECCIONADO === true)
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE === '' || isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE)) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe ingresar el número del comprobante'
      });
      return
    }
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].VEN_CODIGO === '' || isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].VEN_CODIGO)) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe seleccionar un vendedor'
      });
      return
    }
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CONCEPTO === '' || isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CONCEPTO)) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe ingresar el concepto del cobro'
      });
      return
    }
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION === '' || isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION)) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe ingresar la fecha del cobro'
      });
      return
    }
    if (this.cxccobromultipleService.cxcdetcobmulti[this.indicador].length === 0) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'El detalle de los documentos no puedes estar vacío'
      });
      return
    }
    if (Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE) === 0) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'El total a cobrar no puede ser cero'
      });
      return
    }
    if (Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE) !== Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].TOTALVAR)) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'El total de los documentos no es igual al total de la forma de pago más varios'
      });
      return
    }

    if (Object.entries(docselected).length === 0) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Debe seleccionar al menos un documento'
      });
      return
    }

    await this.finguardar()
  }
  async finguardar() {
    try {

      let enccod = ''
      if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.toString().includes('-')) {
        this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION = this.datePipe.transform(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION, 'dd/MM/yyyy')
      }
      this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE = Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE)
      const rs = await this.cxccobromultipleService.insertaenccobmulti(this.cxccobromultipleService.cxcenccobmulti[this.indicador])
      if (rs !== null) {
        for (const item of rs) {
          enccod = item[':B2']
          this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO = enccod
          if (await this.guardardetalle(enccod)) {
            if (await this.guardarformaPago(enccod)) {

              if (await this.guardartrnvarios(enccod)) {
                if (await this.generarasiento(enccod)) {
                  if (await this.generaComprobantesIngreso(enccod) === false) {
                    await this.reversaGrabacionTransacciones(enccod)
                  } else {
                    this.encontrarregistro(enccod)
                    this.messageService.add({
                      key: 'cobmul',
                      severity: 'success',
                      summary: 'Información',
                      detail: 'Éxito al guardar '
                    });
                  }
                } else {
                  await this.reversaGrabacionTransacciones(enccod)
                }
              } else {
                await this.reversaGrabacionTransacciones(enccod)
              }
            } else {
              await this.reversaGrabacionTransacciones(enccod)
            }
          } else {
            await this.reversaGrabacionTransacciones(enccod)
          }
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error ' + error.error
      });

      return;
    }
  }
  async generaComprobantesIngreso(enccod) {
    try {
      let bool = true
      await this.cxccobromultipleService.generarcomprobantemulti(enccod);
      return bool
    } catch (error) {

      return false;
    }
  }
  async generarasiento(codigo) {
    try {
      let bool = true
      const rs = await this.cxccobromultipleService.generarasientocobmulti(codigo)
      if (rs !== null) {
        for (const iterator of rs) {
          this.cxccobromultipleService.cxcenccobmulti[this.indicador].ASI_NRO = iterator[':B1']
        }
      }
      return bool
    } catch (error) {

      return false
    }
  }
  async guardartrnvarios(codigo) {
    try {
      let bool = true
      if (this.cxccobromultipleService.cxctrnvariosarray[this.indicador].length > 0) {
        for (const iterator of this.cxccobromultipleService.cxctrnvariosarray[this.indicador]) {
          if (Number(iterator.DEBE) > 0) {
            iterator.TRNVARIOS_IMPORTE = Number(Number(iterator.DEBE).toFixed(2))
          } else {
            iterator.TRNVARIOS_IMPORTE = Number(Number(iterator.HABER).toFixed(2)) * -1
          }
          iterator.TRNCOBRO_NRODOC = codigo
          iterator.TRNCOBRO_NROCOMPROBANTE = this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE
          await this.cxccobromultipleService.insertarvarios(iterator)
          this.auditoriagral.registrarAuditoria('CXC_TRNVARIOS_MUL',
            codigo + '/' + iterator.CON_CODIGO + '/' + iterator.TRNVARIOS_IMPORTE, 'I',
            '', '01', '', '', '', '').subscribe();
        }
      }
      return bool
    } catch (error) {

      return false
    }
  }
  async guardarformaPago(codigo) {
    try {
      let bool = true
      if (this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length > 0) {
        await this.cxccobromultipleService.eliminarbancaj(codigo)
        for (const iterator of this.cxccobromultipleService.cxctrnformapagoarray[this.indicador]) {
          iterator.TRNPAGO_IMPORTE = Number(iterator.TRNPAGO_IMPORTE);
          iterator.TRNCOBRO_NRODOC = codigo
          if (iterator.TRNPAGO_FECHA.toString().includes('-')) {
            iterator.TRNPAGO_FECHA = this.datePipe.transform(iterator.TRNPAGO_FECHA, 'dd/MM/yyyy')
          }
          if (iterator.TRNPAGO_TIPO === 'EF' || iterator.TRNPAGO_TIPO === 'CH' || iterator.TRNPAGO_TIPO === 'TA') {
            await this.cxccobromultipleService.insertacaja(iterator);
            this.auditoriagral.registrarAuditoria('BAN_TRNCAJ',
              codigo + '/' + iterator.TRNPAGO_TIPO + '/' + iterator.TRNPAGO_NUMERO, 'I',
              '', '01', '', '', '', '').subscribe();
          }
          if (iterator.TRNPAGO_TIPO === 'DP') {
            await this.cxccobromultipleService.insertabanco(iterator)
            this.auditoriagral.registrarAuditoria('BAN_TRNBAN',
              codigo + '/' + iterator.TRNPAGO_TIPO + '/' + iterator.TRNPAGO_NUMERO, 'I',
              '', '01', '', '', '', '').subscribe();
          }
        }
      }
      return bool
    } catch (error) {
      return false
    }
  }
  async guardardetalle(codigo) {
    let bool = true
    try {
      for (const iterator of this.cxccobromultipleService.cxcdetcobmulti[this.indicador]) {
        if (iterator.SELECCIONADO) {
          iterator.ENCCOB_CODIGO = codigo;
          iterator.DETCOB_IMPORTE = Number(iterator.DETCOB_IMPORTE);
          await this.cxccobromultipleService.insertadetcobmulti(iterator);
          if (iterator.CONTRO_GRABAR === '') {
            this.auditoriagral.registrarAuditoria('CXC_DETCOBRO_MULTIPLE',
              codigo + '/' + iterator.DETCOB_NROCOMPROBANTE + '', 'I',
              '', '01', '', '', '', '').subscribe();
          } else {
            this.auditoriagral.registrarAuditoria('CXC_DETCOBRO_MULTIPLE',
              codigo + '/' + iterator.DETCOB_NROCOMPROBANTE + '', 'A',
              '', '01', '', '', '', '').subscribe();
          }
        }
      }
      return bool
    } catch (error) {
      await this.reversaGrabacionTransacciones(codigo)
      return false
    }

  }
  async reversaGrabacionTransacciones(enccod) {
    try {
      if (this.nuevoreg === false) {
        return
      }
      await this.cxccobromultipleService.reversastransacciones(enccod)
      this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO = '';
      for (const iterator of this.cxccobromultipleService.cxcdetcobmulti[this.indicador]) {
        iterator.CONTRO_GRABAR = '';
      }
    } catch (error) {
      console.log(error)
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.botonAsiento = true;
    this.botonVerAsiento = true;

    this.selectAll = false;
    this.datedesde = new Date()
    this.datehasta = new Date()
    this.indiceTablas = 0;
    this.nuevoreg = true;
    this.cxccobromultipleService.cxcenccobmulti[this.indicador] = {}
    this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = []
    this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = [];
    this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = [];
    this.detalleFormaPago = {}
    this.cxcdetcobmultiSelected = {}
    this.strCodigoContable = '';

    const dato: Cxcenccobmulti = {
      ASI_NRO: '',
      COM_CODIGO: '01',
      ENCCOB_CODIGO: '',
      ENCCOB_COMPROBANTE: '',
      ENCCOB_CONCEPTO: '',
      ENCCOB_FECHAEMISION: new Date(),
      ENCCOB_IMPORTE: Number(0).toFixed(2),
      ENCCOB_IMPRESO: '',
      TOTALDEUDA: Number(0).toFixed(2),
      TOTALVAR: Number(0).toFixed(2),

      VEN_CODIGO: '',
      VEN_NOMBRE: '',
    }
    this.cxccobromultipleService.cxcenccobmulti[this.indicador] = dato
    document.getElementById('contorno').style.pointerEvents = 'all';
    this.aggrid.habilitarGrid();
    document.getElementById('ENCCOB_COMPROBANTE').focus();
  }
  async cancelar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAsiento = true;
    this.botonVerAsiento = true;
    this.activeIndex = 0;
    this.indiceTablas = 0;
    this.datedesde = '';
    this.datehasta = '';
    this.selectAll = false;
    this.strCodigoContable = ''

    let codigo = this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO;
    if (isNullOrUndefined(codigo) || codigo === '') {
      this.cxccobromultipleService.cxcenccobmulti[this.indicador] = {}
      this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = []
      this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = [];
      this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = [];
      this.cxcdetcobmultiSelected = {}
      this.detalleVariosSeleccionado = {}


      document.getElementById('contorno').style.pointerEvents = 'none';
      this.aggrid.bloquearGrid();
    } else {
      await this.encontrarregistro(codigo)
      document.getElementById('contorno').style.pointerEvents = 'all';
      this.aggrid.habilitarGrid();
    }
  }
  async encontrarregistro(codigo) {
    this.datedesde = new Date()
    this.datehasta = new Date()
    try {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      this.botonAsiento = false;
      this.botonVerAsiento = false;

      this.activeIndex = 0;
      this.indiceTablas = 0;
      this.selectAll = false;
      this.nuevoreg = false;
      this.cxccobromultipleService.cxcenccobmulti[this.indicador] = {}
      this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = []
      this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = [];
      this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = [];
      this.detalleVariosSeleccionado = {}
      this.detalleFormaPago = {}
      this.cxcdetcobmultiSelected = {}
      let nuevodetallefin: Cxctrnformapago[] = []

      const rs = await this.cxccobromultipleService.getenccxccobmulti(codigo)
      if (rs !== null && rs.length > 0) {
        for (const iterator of rs) {
          iterator.ENCCOB_FECHAEMISION = new Date(iterator.ENCCOB_FECHAEMISION)
          iterator.ENCCOB_IMPORTE = Number(iterator.ENCCOB_IMPORTE).toFixed(2)
          this.cxccobromultipleService.cxcenccobmulti[this.indicador] = iterator;

          const data1 = await this.cxccobromultipleService.getdetcxccobmulti(codigo)
          const data2 = await this.cxccobromultipleService.getformpagocobmulticaj(codigo)
          const data3 = await this.cxccobromultipleService.getformpagocobmultiban(codigo)
          const data4 = await this.cxccobromultipleService.gettrnvariospagomulti(codigo)
          console.log(data3)
          if (data1 !== null && data1.length > 0) {
            for (const item1 of data1) {
              item1.DETCOB_IMPORTE = Number(item1.DETCOB_IMPORTE).toFixed(2)
              item1.SELECCIONADO = true;
            }
            this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = data1;
          }
          if (data2 !== null && data2.length > 0) {
            let nuevodetalle: Cxctrnformapago = {}
            for (const item2 of data2) {
              nuevodetalle.CAJ_CODIGO = item2.CAJ_CODIGO
              nuevodetalle.TRNPAGO_FECHA = this.datePipe.transform(item2.TRNCAJ_FECHA, 'dd/MM/yyyy')
              nuevodetalle.TRNPAGO_TIPO = item2.TRNCAJ_TIPO;
              nuevodetalle.TRNPAGO_NUMERO = item2.TRNCAJ_NUMERO
              nuevodetalle.TRNCOBRO_NRODOC = item2.TRNCAJ_DOCNRO
              nuevodetalle.TRNPAGO_IMPORTE = Number(item2.TRNCAJ_IMPORTE).toFixed(2)
              nuevodetalle.TRNPAGO_CONCEPTO = item2.TRNCAJ_DESCRIPCION
              nuevodetalle.TRNPAGO_NROCTA = item2.TRNPAGO_NROCTA
            }
            nuevodetallefin.push(nuevodetalle);
          }
          if (data3 !== null && data3.length > 0) {
            let nuevodetalle: Cxctrnformapago = {}
            for (const item3 of data3) {
              nuevodetalle.BANCLI_CODIGO = item3.BAN_CODIGO
              nuevodetalle.TRNPAGO_FECHA = this.datePipe.transform(item3.TRNBAN_FECHA, 'dd/MM/yyyy')
              nuevodetalle.TRNPAGO_TIPO = item3.TRNBAN_TIPO;
              nuevodetalle.TRNPAGO_NUMERO = item3.TRNBAN_NUMERO
              nuevodetalle.TRNCOBRO_NRODOC = item3.TRNBAN_DOCNRO
              nuevodetalle.TRNPAGO_IMPORTE = Number(item3.TRNBAN_IMPORTE).toFixed(2)
              nuevodetalle.TRNPAGO_CONCEPTO = item3.TRNBAN_DESCRIPCION
              nuevodetalle.TRNPAGO_NROCTA = item3.TRNPAGO_NROCTA
              nuevodetalle.CON_CODIGO = item3.CON_CODIGO
            }
            nuevodetallefin.push(nuevodetalle);
          }
          if (data4 !== null && data4.length > 0) {
            for (const item4 of data4) {
              if (item4.TRNVARIOS_IMPORTE < 0) {
                item4.HABER = Number(item4.TRNVARIOS_IMPORTE).toFixed(2)
                item4.DEBE = Number('0').toFixed(2)
              } else {
                item4.DEBE = Number(item4.TRNVARIOS_IMPORTE).toFixed(2)
                item4.HABER = Number('0').toFixed(2)
              }
            }
            this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = data4
          }
          this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = nuevodetallefin;
          this.cxccobromultipleService.calcularTotalFormaPago();
          this.cxccobromultipleService.calcularImporteTotal();
          //console.log(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador])

        }

        document.getElementById('contorno').style.pointerEvents = 'all';
      }
    } catch (error) {
      console.log(error)
    }
  }
  changeTabs() {

  }
  cambiarFoco(event) {
    let element: any;
    switch (event.target.id) {
      case 'ENCCOB_COMPROBANTE': {
        element = document.getElementById('VEN_CODIGO');
        break;
      }
      case 'ENCCOB_FECHAEMISION': {
        //this.busquedacliente(event.target.value);
        element = document.getElementById('VEN_CODIGO');
        break;
      } case 'VEN_CODIGO': {
        //this.busquedacliente(event.target.value);
        //element = document.getElementById('CEN_CODIGO');
        this.busquedavendedor(event.target.value)
        break;
      } case 'DESDE': {
        //this.busquedacliente(event.target.value);
        //element = document.getElementById('CEN_CODIGO');
        element = document.getElementById('HASTA');
        break;
      }
      default: {
        break;
      }
    }
    console.log(element)
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  cambio(evento) {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.botonAsiento = true;
    this.botonVerAsiento = true;
  }
  async consultardocs() {
    try {
      let desde = ''
      let hasta = ''
      if (this.datedesde.toString().includes('-')) {
        desde = this.datePipe.transform(this.datedesde, 'dd/MM/yyyy')
      } else {
        desde = this.datedesde
      }
      if (this.datehasta.toString().includes('-')) {
        hasta = this.datePipe.transform(this.datehasta, 'dd/MM/yyyy')
      } else {
        hasta = this.datehasta
      }
      const rs = await this.cxccobromultipleService.desplegarDocumentos(desde, hasta)
      if (rs !== null) {
        let cxcdetdocs: Cxcdetcobmulti[] = []
        let cxcdetdocumento: Cxcdetcobmulti = {}
        let strTipoDoc = '';
        this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = [];
        for (const iterator of rs) {
          cxcdetdocumento = {}
          cxcdetdocumento.SELECCIONADO = false;
          cxcdetdocumento.DETCOB_NRODOC = iterator.DOCUMENTO;
          cxcdetdocumento.DETCOB_FECHA = this.datePipe.transform(iterator.FECHA, 'dd/MM/yyyy');
          cxcdetdocumento.DETCOB_CONCEPTO = iterator.CONCEPTO;
          cxcdetdocumento.DETCOB_SALDOINI = Number(iterator.SALDO).toFixed(2);
          cxcdetdocumento.VEN_NOMBRE = iterator.VENDEDOR;
          cxcdetdocumento.APLORG_CODIGO = iterator.APLORG_CODIGO;
          cxcdetdocumento.DETCOB_IMPORTE = Number(0).toFixed(2)
          cxcdetdocumento.CLI_NOMBRE = iterator.CLI_NOMBRE;
          cxcdetdocumento.CONTRO_GRABAR = ''

          if (iterator.TRNCOBRO_TIPODOC === 'FC') {
            strTipoDoc = "F";
          } else {
            strTipoDoc = iterator.TRNCOBRO_TIPODOC;
          }
          cxcdetdocumento.DETCOB_REF = (strTipoDoc);
          cxcdetdocumento.CLI_CODIGO = iterator.CLI_CODIGO;
          cxcdetdocumento.DETCOB_FECHAVENC = this.datePipe.transform(iterator.FECHAVENCE, 'dd/MM/yyyy');
          cxcdetdocs.push(cxcdetdocumento)
        }
        this.cxccobromultipleService.cxcdetcobmulti[this.indicador] = cxcdetdocs
        this.aggrid.refreshaggrid(this.cxccobromultipleService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto);
        this.cxccobromultipleService.calcularTotalDeuda()
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmul',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar los documentos ' + error.error
      });
      console.log(error)
    }
  }
  buscarregistro() {

    this.opcionbusqueda = 'BUSCARREGISTRO';
    this.types = [
      { label: 'Código', value: 'ENCCOB_CODIGO' },
      { label: 'Comprobante', value: 'ENCCOB_COMPROBANTE' },
      { label: 'Fecha Emisión', value: 'ENCCOB_FECHAEMISION' },
      { label: 'Importe', value: 'ENCCOB_IMPORTE' },
      { label: 'Concepto', value: 'ENCCOB_CONCEPTO' }
    ];
    this.busquedacampos = ['', '', '', '', ''];
    this.tabla = 'CXC_ENCCOBRO_MULTIPLE';
    this.where = ' ENCCOB_ORIGEN is null ';

    this.busqService.busquedacxcencocbmulti().subscribe((datos: any[]) => {
      if (datos !== null) {
        datos.map(x => {
          x.ENCCOB_IMPORTE = Number(x.ENCCOB_IMPORTE).toFixed(2)
          x.ENCCOB_FECHAEMISION = this.datePipe.transform(x.ENCCOB_FECHAEMISION, 'dd/MM/yyyy')
        })
        this.arregloCons = datos;
        this.spin = false;
        this.displayDialogBusquedaFast = true;
      }
    });
  }
  busquedavendedor(parametro) {
    if (parametro === null) {
      parametro = '';
    }
    this.opcionbusqueda = 'vendedor';
    this.types = [
      { label: 'Código', value: 'VEN_CODIGO' },
      { label: 'Nombre', value: 'VEN_NOMBRE' }
    ];
    this.busquedacampos = [parametro, ''];
    this.tabla = 'VEN_MAEVENDEDOR';
    this.where = '';

    this.cxccobromultipleService.erBusquedaVendedor('*', this.tabla, this.types[0].value, parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.cxccobromultipleService.cxcenccobmulti[this.indicador].VEN_NOMBRE = eR[0].VEN_NOMBRE;
          document.getElementById('ENCCOB_CONCEPTO').focus();
        } else {
          this.spin = true;
          this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.spin = false;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.spin = true;
        this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.spin = false;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'vendedor') {
      this.cxccobromultipleService.cxcenccobmulti[this.indicador].VEN_CODIGO = opcion.VEN_CODIGO
      this.cxccobromultipleService.cxcenccobmulti[this.indicador].VEN_NOMBRE = opcion.VEN_NOMBRE
      this.strCodigoContable = isNullOrUndefined(opcion.CON_CODIGO) ? '' : opcion.CON_CODIGO

      document.getElementById('ENCCOB_CONCEPTO').focus()
    }
    if (this.opcionbusqueda === 'BUSCARREGISTRO') {
      this.encontrarregistro(opcion.ENCCOB_CODIGO)
    }
    this.displayDialogBusquedaFast = false
  }
  seleccionarTodos() {
    if (this.selectAll === true) {
      for (const iterator of this.cxccobromultipleService.cxcdetcobmulti[this.indicador]) {
        iterator.SELECCIONADO = true
        iterator.DETCOB_IMPORTE = Number(iterator.DETCOB_SALDOINI).toFixed(2)
      }
    } else {
      for (const iterator of this.cxccobromultipleService.cxcdetcobmulti[this.indicador]) {
        iterator.SELECCIONADO = false
        iterator.DETCOB_IMPORTE = Number(0).toFixed(2)
      }
    }
    this.cxccobromultipleService.calcularImporteTotal()
    this.aggrid.refreshaggrid(this.cxccobromultipleService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto);
  }
  actualizarTablas() {

  }
  docSeleccionado(valor) {

    const indi = this.cxccobromultipleService.cxcdetcobmulti[this.indicador].indexOf(valor.data);
    console.log(indi)
    console.log(valor.data.SELECCIONADO)
    this.cxcdetcobmultiSelected = valor.data;
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO !== '') {
      valor.data.SELECCIONADO = true
      this.aggrid.refreshaggridindexSNMVSCROLL(this.cxccobromultipleService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto, indi - 1)
      return
    }
    if (valor.data.SELECCIONADO) {

      valor.data.DETCOB_IMPORTE = Number(valor.data.DETCOB_SALDOINI).toFixed(2);

      this.aggrid.refreshaggridindexSNMVSCROLL(this.cxccobromultipleService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto, indi - 1)
      this.cxccobromultipleService.calcularImporteTotal();
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefcxccobmulti.objeto].setFocusedCell(indi, 'SELECCIONADO');

    } else {
      valor.data.DETCOB_IMPORTE = 0;
      valor.data.DETCOB_IMPORTE = Number(valor.data.DETCOB_IMPORTE).toFixed(2);
      valor.data.DETCOB_SALDOINI = Number(valor.data.DETCOB_SALDOINI).toFixed(2);

      this.aggrid.refreshaggridindexSNMVSCROLL(this.cxccobromultipleService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto, indi - 1)
      this.cxccobromultipleService.calcularImporteTotal();
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefcxccobmulti.objeto].setFocusedCell(indi, 'SELECCIONADO');
    }

  }
  isEditFP(data) {
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO !== '' && isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO) === false) {
      return false;
    }
    return true;
  }
  isEditFPcaja(data) {
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO !== '' && isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO) === false) {
      return false
    } else if (data.TRNPAGO_TIPO === 'DP') {
      return false
    }
    return true
  }
  isEditFPtrnban(data) {
    if (this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO !== '' && isNullOrUndefined(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO) === false) {
      return false
    } else if (data.TRNPAGO_TIPO === 'DP') {
      return true
    }
    return false
  }
  seleccionDocumento(params) {
    if (params.object !== undefined) {
      this.cxcdetcobmultiSelected = params.object;

    }
  }
  seleccionFormaPago(valor) {
    if (valor === 'nuevo') {

      this.nuevaFormaPago();
    } else if (valor === 'eliminar') {

      this.eliminarformpago();
    } else if (valor === 'cancelar') {

      this.cancelarFormaPago();
    }
    if (valor.object !== undefined) {
      this.detalleFormaPago = valor.object;
    }
  }
  cancelarFormaPago() {
    if (this.detalleFormaPago.LINEA !== undefined && this.detalleFormaPago.TRNPAGO_TIPO.length === 0) {
      this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].splice(
        this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].findIndex(det =>
          det.LINEA === this.detalleFormaPago.LINEA && det.TRNPAGO_TIPO === this.detalleFormaPago.TRNPAGO_TIPO), 1);
      if (this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length > 0) {
        this.detalleFormaPago = this.cxccobromultipleService.cxctrnformapagoarray[this.indicador]
        [this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length - 1];
      }
      this.cxccobromultipleService.calcularTotalFormaPago();
      this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefCarteraFormaPago.objeto);
    }
  }
  eliminarformpago() {
    this.cxccobromultipleService.cxctrnformapagoarray[this.indicador] = this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].filter((val, j) => j !==
      this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago));
    this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefCarteraFormaPago.objeto);
    this.cxccobromultipleService.calcularTotalFormaPago();
  }
  nuevaFormaPago() {
    //this.editpagofr = false;
    // this.btnNuevoGrid = true;
    // this.btnGuardarGrid = false;
    // this.btnBorrarGrid = false;
    // this.btnCancelarGrid = false;
    const linea = this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length;
    const nuevodetalle = {
      TRNCOBRO_NRODOC: '',
      TRNPAGO_TIPO: '',
      CAJ_CODIGO: '',
      TRNPAGO_NUMERO: '',
      TRNPAGO_CONCEPTO: this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CONCEPTO,
      TRNPAGO_IMPORTE:
        Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE) - Number(this.cxccobromultipleService.cxcenccobmulti[this.indicador].TOTALVAR),
      BANCLI_CODIGO: '',
      BANCLI_NOMBRE: '',
      TRNPAGO_NROCTA: '',
      TRNPAGO_CODSRI: '',
      TRNPAGO_TIPDIS: '',
      TRNPAGO_FECHA: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      CON_CODIGO: '',
      CLI_CODIGO: '',
      TRNCHEPOS_NUMDOC: '',
      LINEA: String(linea + 1),
      TRNPAGO_ORIGEN: 'CXC'
    };
    this.detalleFormaPago = nuevodetalle;
    if (this.detalleFormaPago !== undefined && this.detalleFormaPago !== null) {
      const indi = this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago);
      if (indi === -1) {
        this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].push(nuevodetalle);
        this.detalleFormaPago = this.cxccobromultipleService.cxctrnformapagoarray[this.indicador][this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length - 1];
        this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefCarteraFormaPago.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefCarteraFormaPago.objeto].setFocusedCell(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].length - 1, 'TRNPAGO_TIPO');
        this.cxccobromultipleService.calcularTotalFormaPago();
      } else {
        this.cxccobromultipleService.cxctrnformapagoarray[this.indicador].splice(indi + 1, 0, nuevodetalle);
        this.aggrid.refreshaggridindex(this.cxccobromultipleService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefCarteraFormaPago.objeto, indi);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefCarteraFormaPago.objeto].setFocusedCell(indi + 1, 'TRNPAGO_TIPO');
        this.cxccobromultipleService.calcularTotalFormaPago();
      }
    }
  }

  seleccionVarios(valor) {
    if (valor === 'nuevo') {
      this.nuevoVario();
    } else if (valor === 'eliminar') {
      this.confirmarEliminarVarios();
    } else if (valor === 'cancelar') {
      //this.cancelarVarios();
    }
    if (valor.object !== undefined) {
      this.detalleVariosSeleccionado = valor.object;
    }
  }
  nuevoVario() {
    const linea = this.cxccobromultipleService.cxctrnvariosarray[this.indicador].length;
    const nuevodetalle = {
      CON_CODIGO: this.strCodigoContable,
      CON_NOMBRE: '',
      TRNVARIOS_IMPORTE: Number(0).toFixed(2),
      DEBE: Number(0).toFixed(2),
      HABER: Number(0).toFixed(2),
      TRNVARIOS_LINEA: 0,
      CLI_CODIGO: '',
      TRNCOBRO_NRODOC: this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO,
      BAN_CODIGO: '',
      TRNBAN_TIPO: '',
      TRNBAN_NUMERO: '',
      TRNCOBRO_NROCOMPROBANTE: this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE,
      LINEA: String(linea + 1),
      CEN_CODIGO: '',

    };
    if (this.detalleVariosSeleccionado !== undefined && this.detalleVariosSeleccionado !== null) {
      const indi = this.cxccobromultipleService.cxctrnvariosarray[this.indicador].indexOf(this.detalleVariosSeleccionado);
      if (indi === -1) {
        this.cxccobromultipleService.cxctrnvariosarray[this.indicador].push(nuevodetalle);
        this.detalleVariosSeleccionado = this.cxccobromultipleService.cxctrnvariosarray[this.indicador][this.cxccobromultipleService.cxctrnvariosarray[this.indicador].length - 1];
        this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnvariosarray[this.indicador], this.defaultColumnDefCarteraVarios.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefCarteraVarios.objeto].setFocusedCell(this.cxccobromultipleService.cxctrnvariosarray[this.indicador].length - 1, 'CON_CODIGO');

      } else {
        this.cxccobromultipleService.cxctrnvariosarray[this.indicador].splice(indi + 1, 0, nuevodetalle);
        this.aggrid.refreshaggridindex(this.cxccobromultipleService.cxctrnvariosarray[this.indicador], this.defaultColumnDefCarteraVarios.objeto, indi);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefCarteraVarios.objeto].setFocusedCell(indi + 1, 'CON_CODIGO');

      }
    }
  }
  confirmarEliminarVarios() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro seleccionado',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      key: 'cobmulConf',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        this.eliminarVarios();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async eliminarVarios() {
    if (this.detalleVariosSeleccionado !== undefined) {
      // this.editpagofr = false;
      // this.btnNuevoGrid = false;
      // this.btnGuardarGrid = false;
      // this.btnBorrarGrid = false;
      // this.btnCancelarGrid = false;
      if (this.detalleVariosSeleccionado.TRNVARIOS_LINEA === 0) {
        this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = this.cxccobromultipleService.cxctrnvariosarray[this.indicador].filter((val, j) => j !==
          this.cxccobromultipleService.cxctrnvariosarray[this.indicador].indexOf(this.detalleVariosSeleccionado));
        this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnvariosarray[this.indicador], this.defaultColumnDefCarteraVarios.objeto);
        this.cxccobromultipleService.calcularTotalFormaPago()
      } else {
        await this.cxccobromultipleService.eliminartrnvarios(this.detalleVariosSeleccionado);
        await this.auditoriagral.registrarAuditoria('CXC_TRNVARIOS_MUL',
          this.cxccobromultipleService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO + '/' + this.detalleVariosSeleccionado.CON_CODIGO, 'E',
          '', '01', '', '', '', '').toPromise();
        this.cxccobromultipleService.cxctrnvariosarray[this.indicador] = this.cxccobromultipleService.cxctrnvariosarray[this.indicador].filter((val, j) => j !==
          this.cxccobromultipleService.cxctrnvariosarray[this.indicador].indexOf(this.detalleVariosSeleccionado));
        this.aggrid.refreshaggrid(this.cxccobromultipleService.cxctrnvariosarray[this.indicador], this.defaultColumnDefCarteraVarios.objeto);
        this.cxccobromultipleService.calcularTotalFormaPago()
      }
    }
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }

  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
}
